import { Http } from '@/services/http.init'

export default {
  data: function () {
    return {
      page: 2,
      limit: 5,
      lastPage: 0
    }
  },

  methods: {
    infiniteHandler: function (state, type, url, parameters = {}) {
      const p = { pageIndex: this.page, pageSize: this.limit }
      const params = {
        ...p,
        ...parameters
      }
      setTimeout(function () {
        new Http({ auth: true }).get(url, { params })
          .then(response => {
            if (response.data.data.length > 0) {
              this.lastPage = Math.ceil(response.data.meta.totalRow / this.limit)
              this.$store.commit(`${type}/ADD_ITEMS`, response.data.data)

              if (this.page - 1 === this.lastPage) {
                this.page = 2
                state.complete()
              } else {
                this.page += 1
              }

              state.loaded()
            } else {
              this.page = 2
              state.complete()
            }
          })
          .catch(e => console.log(e))
      }.bind(this, state), 1000)
    }
  }
}
